module.exports = __webpack_public_path__ + "media/night/335-208e7779.svg";